import { createContext } from 'react';
const noGenericChannelsWithCapabilitiesDefined = () => {
  throw new Error(`EditorCapabilitiesContext not defined. Wrap this component with a EditorCapabilitiesProvider.`);
};
export const EditorCapabilitiesContext = /*#__PURE__*/createContext({
  editorConfigKey: 'UNSET',
  getChannelData: noGenericChannelsWithCapabilitiesDefined
});